import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import HeadSub from '../../../../components/comm/HeadSub';

import URL from '../../../../constants/url';
import style from './FoodSearch.module.css';
import axiosApi from '../../../../api/daonAxios';

import ToastPopup from '../../../../components/comm/ToastPopup'




// 두잉랩 API 최소 호출 간격
const SEARCH_INTERVAL = 300;


const FoodSearch = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const location = useLocation();
    const { state } = location;

    const saveGbn = state?.saveGbn;
    const ntktmTyCd = state?.ntktmTyCd;
    const recDe = state?.recDe;

    const foodLensId = state?.foodLensId;

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const inputRef = useRef(null);

    // 마지막 API 호출 시간
    const lastSearchTimeRef = useRef(0);

    // 300ms 이내 재검색 시 예약
    const searchTimerRef = useRef(null);

    // 이전 API 응답이 최신 API 결과를 덮어쓰지 않도록 사용
    const requestSeqRef = useRef(0);


    const [query, setQuery] = useState('');

    const [showResults, setShowResults] = useState(false);

    const [searchResults, setSearchResults] = useState([]);

    const [searching, setSearching] = useState(false);

    const [activeTab, setActiveTab] = useState('recent');

    /**
     * 내 음식
     */
    const [myFoods, setMyFoods] = useState([]);


    useEffect(() => {
        fetchMyFoodCnddteList();
    }, []);

    /**
     * 최근 검색
     */
    const [recentSearches, setRecentSearches] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('recentFoods') || '[]');
        } catch {
            return [];
        }
    });


    const fetchMyFoodCnddteList = async () => {
        try {
            const jToken = localStorage.getItem("jToken");

            const res = await axiosApi.get("/diet/myFoodCnddteList", {
                headers: {
                    Authorization: `Bearer ${jToken}`,
                },
            });
            setMyFoods(res.data.result ?? []);

        } catch (err) {
            console.error(err);
        }
    };


    /**
     * 최근 검색 저장
     */
    const saveRecent = (food) => {

        const next = [
            food,
            ...recentSearches.filter(
                item => item.id !== food.id
            )
        ].slice(0, 10);

        setRecentSearches(next);

        localStorage.setItem('recentFoods',JSON.stringify(next));
    };


    /**
     * 최근 검색 삭제
     */
    const removeRecent = (id) => {
        const next = recentSearches.filter(
            item => item.id !== id
        );
        setRecentSearches(next);
        localStorage.setItem('recentFoods',JSON.stringify(next));
    };


    /**
     * 최근 검색 전체 삭제
     */
    const clearAllRecent = () => {
        setRecentSearches([]);
        localStorage.removeItem('recentFoods');
    };


    /**
     * 내 음식 삭제
     */
    const removeMyFood = async (id) => {
        const url = "/diet/myFoodCnddte";
        const jToken = localStorage.getItem('jToken');

        const reqOptions = { 
            params : {myFoodCnddteId : id},
            headers: { Authorization: `Bearer ${jToken}` } 
        };

        await axiosApi.delete(url, reqOptions)
        .then((res) => {
            if(res.status === 200) {
                fetchMyFoodCnddteList();
            } else {
            }
        })
        .catch(error => {
            console.error(error);
        }).finally(() => {

        })
    };


    /**
     * 내 음식 전체 삭제
     */
    const clearAllMyFoods = () => {
        removeMyFood(null);
    };


    /**
     * 두잉랩 api 음식 선택
     */
    const handleSelect = useCallback((food) => {
        saveRecent(food);
        if(saveGbn === "I") {
            saveFoodLens(ntktmTyCd, recDe, food.id);
        } else {
            changeFoodLens(food.id);
        }
    },[saveGbn, ntktmTyCd, recDe]);

    /**
     * 내 음식 선택
     */
    const handleMyFoodSelect = useCallback((food) => {
        if(saveGbn === "I") {
            saveFoodLensMyFood(ntktmTyCd, recDe, food.myFoodCnddteId);
        } else {
            changeFoodLensMyFood(food.myFoodCnddteId);
        }
    },[saveGbn, ntktmTyCd, recDe]);


    /**
     * 두잉랩 음식 검색 API
     */
    const getSearchFoodList = async (searchTxt) => {

        const keyword = searchTxt.trim();

        if (!keyword) {
            return;
        }

        /*
         * 현재 요청 번호
         */
        const requestSeq = ++requestSeqRef.current;

        lastSearchTimeRef.current = Date.now();

        const url = '/diet/searchFoodList';

        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            params: {
                searchTxt: keyword
            },
            headers: {
                Authorization: `Bearer ${jToken}`
            }
        };

        try {
            setSearching(true);
            const res = await axiosApi.get(url, reqOptions);

            /*
             * 이전 요청이면 무시
             */
            if (requestSeq !== requestSeqRef.current) {
                return;
            }

            if (res.status === 200) {

                const result =  res.data?.result ?? [];

                const uniqueResult = Array.from(
                    new Map(
                        result.map(food => [food.id, food])
                    ).values()
                );

                const foodList = uniqueResult.map(food => ({
                    ...food,
                    name: food.foodName,
                    portion: makePortionText(food)
                }));

                setSearchResults(foodList);

                setShowResults(true);
            }

        } catch (err) {
            if (requestSeq ===requestSeqRef.current) {
                console.error('음식 검색 중 오류:', err);
                setSearchResults([]);
                setShowResults(true);
            }
        } finally {
            if (requestSeq === requestSeqRef.current) {
                setSearching(false);
            }
        }
    };


    /**
     * 두잉랩 제공량 문자열
     *
     * ex)
     * countsValue = "1"
     * counts = "국그릇"
     * weight = "232g"
     *
     * → 1국그릇 232g
     */
    const makePortionText = (food) => {

        const parts = [];
        if (food.countsValue && food.counts ) {
            parts.push(`${food.countsValue}${food.counts}`);
        }
        if (food.weight) {
            parts.push(food.weight);
        }
        return parts.join(' ');
    };


    /**
     * 검색
     *
     * Enter 또는 검색 버튼 클릭 시에만 실행
     */
    const handleSearch = () => {

        const keyword = query.trim();

        if (!keyword) {
            return;
        }

        /*
         * 예약된 검색 제거
         */
        if (searchTimerRef.current) {
            clearTimeout(searchTimerRef.current);
            searchTimerRef.current = null;
        }

        const now = Date.now();

        const elapsed = now - lastSearchTimeRef.current;

        /*
         * 마지막 호출로부터 300ms 이상이면
         * 즉시 호출
         */
        if (elapsed >= SEARCH_INTERVAL) {
            getSearchFoodList(keyword);
            return;
        }


        /*
         * 300ms 안 됐으면
         * 남은 시간 후 마지막 검색어 조회
         */
        const remain = SEARCH_INTERVAL - elapsed;


        searchTimerRef.current =
            setTimeout(() => {
                getSearchFoodList(keyword);
                searchTimerRef.current = null;
            }, remain);
    };


    /**
     * 검색어 초기화
     */
    const handleClearQuery = () => {

        if (searchTimerRef.current) {
            clearTimeout(searchTimerRef.current);

            searchTimerRef.current = null;
        }

        /*
         * 이전 API 응답 무효화
         */
        requestSeqRef.current += 1;

        setQuery('');
        setSearchResults([]);
        setShowResults(false);
        setSearching(false);

        inputRef.current?.focus();
    };

    const saveFoodLens = useCallback(async(ntktmTyCd, recDe, foodId) => {
        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        await axiosApi.post('/diet/saveFoodLensRestApi', {ntktmTyCd : ntktmTyCd, recDe : recDe, foodId : foodId}, requestOption)
        .then((res) => {
            if(res.status === 200) {
                if(res.data.result) {
                    navigate(URL.FOOD_RECORD_DETAIL, {state: {ntktmTyCd : ntktmTyCd, recDe : recDe}});
                } else {
                    setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                    setToast(true);
                }
            } else {
                setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                setToast(true);
            }
        })
        .catch(error => {
            console.error(error);
        }).finally(() => {

        })

    },[ntktmTyCd, recDe])


    const changeFoodLens = useCallback(async(foodId) => {
        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        await axiosApi.put('/diet/changeFoodLensRestApi', {foodLensId : foodLensId, foodId : foodId}, requestOption)
        .then((res) => {
            if(res.status === 200) {
                if(res.data.result) {
                    navigate(-1);
                } else {
                    setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                    setToast(true);
                }
            } else {
                setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                setToast(true);
            }
        })
        .catch(error => {
            console.error(error);
        }).finally(() => {

        })
    },[foodLensId])

    //내 음식 저장/변경
    const saveFoodLensMyFood = useCallback(async(ntktmTyCd, recDe, myFoodCnddteId) => {
        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        await axiosApi.post('/diet/saveFoodLensMyFood', {ntktmTyCd : ntktmTyCd, recDe : recDe, myFoodCnddteId : myFoodCnddteId}, requestOption)
        .then((res) => {
            if(res.status === 200) {
                if(res.data.result) {
                    navigate(URL.FOOD_RECORD_DETAIL, {state: {ntktmTyCd : ntktmTyCd, recDe : recDe}});
                } else {
                    setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                    setToast(true);
                }
            } else {
                setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                setToast(true);
            }
        })
        .catch(error => {
            console.error(error);
        }).finally(() => {

        })

    },[ntktmTyCd, recDe])


    const changeFoodLensMyFood = useCallback(async(myFoodCnddteId) => {
        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        await axiosApi.put('/diet/changeFoodLensMyFood', {foodLensId : foodLensId, myFoodCnddteId : myFoodCnddteId}, requestOption)
        .then((res) => {
            if(res.status === 200) {
                if(res.data.result) {
                    navigate(-1);
                } else {
                    setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                    setToast(true);
                }
            } else {
                setToastMessage("문제가 발생하였습니다. 관리자에 문의해주세요.");
                setToast(true);
            }
        })
        .catch(error => {
            console.error(error);
        }).finally(() => {

        })
    },[foodLensId])


    /**
     * 컴포넌트 종료
     */
    useEffect(() => {
        return () => {
            if (searchTimerRef.current) {
                clearTimeout(searchTimerRef.current);
            }
        };
    }, []);


    /**
     * 검색 결과 화면인지
     */
    const isSearching = showResults && query.trim();


    /**
     * 결과 없음
     */
    const noResult = isSearching && !searching && searchResults.length === 0;


    return (
        <>
            <HeadSub title="음식 검색" />

            <div id="sub-content" data-layout="white">

                <div className="inner-wrap" style={{paddingTop: 0, paddingBottom: '7rem'}}>
                    {/* 검색창 */}
                    <div className={style.searchBox}>
                        <input
                            ref={inputRef}
                            type="text"
                            className={style.searchInput}
                            placeholder="음식 이름을 검색하세요."
                            value={query}
                            onChange={(e) => {
                                setQuery(
                                    e.target.value
                                );
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    handleSearch();
                                }
                            }}
                        />

                        {query && (

                            <button type="button"
                                className={style.clearBtn}
                                onClick={handleClearQuery}
                            >
                                <span className="blind">
                                    지우기
                                </span>
                            </button>
                        )}

                        <button type="button"
                            className={style.searchBtn}
                            onClick={handleSearch}
                        >
                            <span className="blind">
                                검색
                            </span>
                        </button>
                    </div>

                    {/* 검색 중 */}
                    {isSearching && searching && (
                        <div className={style.resultSection}>
                            <span className={style.resultLabel}>
                                검색 중...
                            </span>
                        </div>
                    )}

                    {/* 검색 결과 */}
                    {isSearching && !searching && !noResult && (

                        <div className={style.resultSection}>
                            <span className={style.resultLabel}>
                                검색 결과
                            </span>

                            <ul className={style.resultList}>
                                {searchResults.map(food => (
                                    <li key={food.id}>
                                        <button type="button"
                                            className={style.resultItem}
                                            onClick={() =>
                                                handleSelect(food)
                                            }
                                        >
                                            <span className={style.resultIcon}/>
                                            <span>
                                                {food.name}
                                                {food.manufacturer && (
                                                    <>
                                                        {' '}
                                                        ({food.manufacturer})
                                                    </>
                                                )}
                                            </span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}


                    {/* 검색 결과 없음 */}
                    {noResult && (
                        <div className={style.emptyBox}>
                            <div className={style.emptyIcon}/>
                            <p>
                                검색하신 음식을 찾지 못했어요
                            </p>
                            <button
                                className="btn"
                                data-btn-type="fill-main-sub"
                                data-btn-size="smd"
                                data-btn-radius="xsm"
                                type="button"
                                onClick={() =>
                                    navigate(URL.FOOD_MANUAL_ADD, {state: {foodLensId : foodLensId, saveGbn : saveGbn, ntktmTyCd : ntktmTyCd, recDe : recDe}})
                                }
                            >
                                <span>
                                    내 음식 추가
                                </span>
                            </button>
                        </div>
                    )}

                    {/* 검색 전 */}
                    {!isSearching && (
                        <>
                            <div className={style.tabRow}>
                                <div className={style.tabBar}>
                                    <button
                                        type="button"
                                        className={`${style.tab} ${activeTab === 'recent'? style.tabActive : ''}`}
                                        onClick={() => setActiveTab('recent')}
                                    >
                                        최근 검색
                                    </button>


                                    <button
                                        type="button"
                                        className={
                                            `${style.tab} ${ activeTab === 'my' ? style.tabActive : ''}`}
                                        onClick={() => setActiveTab('my')}
                                    >
                                        내 음식
                                    </button>
                                </div>


                                {activeTab === 'recent' && recentSearches.length > 0 && (
                                    <button
                                        type="button"
                                        className={style.clearAllBtn}
                                        onClick={clearAllRecent}
                                    >
                                        전체 삭제
                                    </button>
                                )}

                                {activeTab === 'my' && myFoods.length > 0 && (
                                    <button
                                        type="button"
                                        className={style.clearAllBtn}
                                        onClick={clearAllMyFoods}
                                    >
                                        전체 삭제
                                    </button>
                                )}
                            </div>


                            {/* 최근 검색 */}
                            {activeTab === 'recent' && (
                                <div className={style.listBox}>
                                    {recentSearches.length > 0 ? (
                                        <ul className={style.foodList}>
                                            {recentSearches.map(food => (
                                                <li
                                                    key={food.id}
                                                    className={style.foodItem}
                                                >
                                                    <button
                                                        type="button"
                                                        className={style.foodName}
                                                        onClick={() =>
                                                            handleSelect(food)
                                                        }
                                                    >
                                                        {food.name}
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className={style.foodRemove}
                                                        onClick={() =>
                                                            removeRecent(
                                                                food.id
                                                            )
                                                        }
                                                    >
                                                        ×
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p className={style.listEmpty}>
                                            최근에 검색한 음식이 없어요
                                        </p>
                                    )}
                                </div>
                            )}


                            {/* 내 음식 */}
                            {activeTab === 'my' && (
                                <div className={style.listBox}>
                                    {myFoods.length > 0 ? (
                                        <ul className={style.foodList}>
                                            {myFoods.map(food => (
                                                <li
                                                    key={food.myFoodCnddteId}
                                                    className={style.foodItem}
                                                >
                                                    <button
                                                        type="button"
                                                        className={style.foodInfo}
                                                        onClick={() =>
                                                            handleMyFoodSelect(food)
                                                        }
                                                    >
                                                        <strong>{food.foodName}</strong>
                                                        {food.counts && (
                                                            <span>
                                                                - {`1 ${food.counts} | ${food.servingSize} ${food.unit}`}
                                                            </span>
                                                        )}
                                                    </button>

                                                    <button
                                                        type="button"
                                                        className={style.foodRemove}
                                                        onClick={() =>
                                                            removeMyFood(
                                                                food.myFoodCnddteId
                                                            )
                                                        }
                                                    >
                                                        ×
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    ) : (
                                        <p className={style.listEmpty}>
                                            등록된 음식이 없습니다
                                        </p>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>


            {/* 내 음식 추가 */}
            {!isSearching && activeTab === 'my' && (
                <div className={style.bottomFixed}>
                    <button
                        className={style.addBtn}
                        type="button"
                        onClick={() =>
                            navigate(URL.FOOD_MANUAL_ADD, {state: {foodLensId : foodLensId, saveGbn : saveGbn, ntktmTyCd : ntktmTyCd, recDe : recDe}})
                        }
                    >
                        내 음식 추가
                    </button>
                </div>
            )}

            {toast && <ToastPopup setToast={setToast} message={toastMessage} position="center" opacity="90" />}
        </>
    );
};


export default FoodSearch;